export const ICON_CONTAINER_SIZE = 40;
export const ICON_SIZE = 24;
export const BUTTON_SIZE = 40;
export const IMAGE_SIZE = 40;
